const skills = {
  skills1: [
    {
      skill_name: "HTML5",
      class_name: "bar-expand html5",
    },
    {
      skill_name: "CSS3",
      class_name: "bar-expand css3",
    },
    {
      skill_name: "Bootstrap",
      class_name: "bar-expand bootstrap",
    },
    {
      skill_name: "Responsive Layouts",
      class_name: "bar-expand layout",
    },
    {
      skill_name: "JSON",
      class_name: "bar-expand json",
    },
    {
      skill_name: "jQuery",
      class_name: "bar-expand jquery",
    },
    {
      skill_name: "Google Maps API",
      class_name: "bar-expand google",
    },
    {
      skill_name: "AJAX",
      class_name: "bar-expand ajax",
    },
    {
      skill_name: "WordPress",
      class_name: "bar-expand wordpress",
    },
    {
      skill_name: "Bower",
      class_name: "bar-expand bower",
    },
    {
      skill_name: "Chart.js",
      class_name: "bar-expand vue",
    },
    {
      skill_name: "ngrx",
      class_name: "bar-expand angular",
    },
  ],
  skills2: [
    {
      skill_name: "JavaScript",
      class_name: "bar-expand javascript",
    },
    {
      skill_name: "TypeScript",
      class_name: "bar-expand angular",
    },
    {
      skill_name: "React.js",
      class_name: "bar-expand react",
    },
    {
      skill_name: "Angular.js",
      class_name: "bar-expand angularjs",
    },
    {
      skill_name: "Angular2+",
      class_name: "bar-expand angular",
    },
    {
      skill_name: "Vue.js",
      class_name: "bar-expand vue",
    },
    {
      skill_name: "Yarn",
      class_name: "bar-expand yarn",
    },
    {
      skill_name: "NPM",
      class_name: "bar-expand npm",
    },
    {
      skill_name: "ECAMScript 6",
      class_name: "bar-expand es6",
    },
    {
      skill_name: "Webpack",
      class_name: "bar-expand webpack",
    },
    {
      skill_name: "Grunt",
      class_name: "bar-expand grunt",
    },
    {
      skill_name: "Gulp",
      class_name: "bar-expand gulp",
    },
  ],
};

export default skills;
